import {
    PROYECTO_LOADING,
    PROYECTO_LOADED,
    PROYECTO_ERROR,

    PROYECTO_DETALLE_LOADING,
    PROYECTO_DETALLE_LOADED,
    PROYECTO_DETALLE_ERROR,

    PROYECTO_SOLICITUD_LOADING,
    PROYECTO_SOLICITUD_LOADED,
    PROYECTO_SOLICITUD_ERROR,

    MIS_PROYECTOS_LOADING,
    MIS_PROYECTOS_LOADED,
    MIS_PROYECTOS_ERROR,

    PROYECTO_SOLICITUDES_LOADING,
    PROYECTO_SOLICITUDES_LOADED,
    PROYECTO_SOLICITUDES_ERROR,

    APROBACION_SOLICITUD_LOADING,
    APROBACION_SOLICITUD_LOADED,
    APROBACION_SOLICITUD_ERROR,

    PROYECTO_CREAR_LOADING,
    PROYECTO_CREAR_LOADED,
    PROYECTO_CREAR_ERROR,  
    PROYECTO_CREAR_RESET,

    PROYECTO_EDITAR_LOADING,
    PROYECTO_EDITAR_LOADED,
    PROYECTO_EDITAR_ERROR,  

    PROYECTOS_SELECT_LOADING,
    PROYECTOS_SELECT_LOADED,
    PROYECTOS_SELECT_ERROR
} from './../../types/proyecto';

const INITIAL_STATE = {
    proSelectLoading: false,
    proSelectLoad: false,
    proSelectError: '',
    proSelect: [],

    proEditarLoading: false,
    proEditarLoad: false,
    proEditarError: '',
    proEditar: [],

    proCrearLoading: false,
    proCrearLoad: false,
    proCrearError: '',
    proCrear: [],

    aprobLoading: false,
    aprobLoad: false,
    aprobError: '',
    aprob: [],

    prosolicLoading: false,
    prosolicLoad: false,
    prosolicError: '',
    prosolic: [],

    misproyectosLoading: false,
    misproyectosLoad: false,
    misproyectosError: '',
    misproyectos: [],

    proyectoLoading: false,
    proyectoLoad: false,
    proyectoError: '',
    proyecto: [],

    proyectoDetalleLoading: false,
    proyectoDetalleLoad: false,
    proyectoDetalleError: '',
    proyectoDetalle: [],

    solicitudLoading: false,
    solicitudLoad: false,
    solicitudError: '',
    solicitud: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case PROYECTOS_SELECT_LOADING:
            return {
                ... state,
                proSelectLoading: true,
                proSelectLoad: false,
                proSelectError: '',
                proSelect: []
            } 
        case PROYECTOS_SELECT_LOADED:
            return {
                ...state,
                proSelectLoading: false,
                proSelectLoad: true,
                proSelectError: '',
                proSelect: action.payload,
            };
        case PROYECTOS_SELECT_ERROR:
            return {
                ...state,
                proSelectLoading: false,
                proSelectLoad: false,
                proSelectError: action.payload,
                proSelect: []
            }

        case PROYECTO_EDITAR_LOADING:
            return {
                ... state,
                proEditarLoading: true,
                proEditarLoad: false,
                proEditarError: '',
                proEditar: []
            }
        case PROYECTO_EDITAR_LOADED:
            return {
                ...state,
                proEditarLoading: false,
                proEditarLoad: true,
                proEditarError: '',
                proEditar: action.payload,
                proyectoDetalle: {
                    ...state.proyectoDetalle,
                    ...action.payload 
                }
            };
        case PROYECTO_EDITAR_ERROR:
            return {
                ...state,
                proEditarLoading: false,
                proEditarLoad: false,
                proEditarError: action.payload,
                proEditar: []
            }

        case PROYECTO_CREAR_RESET:
            return {
                ... state,
                proCrearLoading: false,
                proCrearLoad: false,
                proCrearError: '',
                proCrear: [],
                proEditarLoading: false,
                proEditarLoad: false,
                proEditarError: '',
                proEditar: []
            } 
        case PROYECTO_CREAR_LOADING:
            return {
                ... state,
                proCrearLoading: true,
                proCrearLoad: false,
                proCrearError: '',
                proCrear: []
            }
        case PROYECTO_CREAR_LOADED:
            return {
                ...state,
                proCrearLoading: false,
                proCrearLoad: true,
                proCrearError: '',
                proCrear: action.payload 
            };
        case PROYECTO_CREAR_ERROR:
            return {
                ...state,
                proCrearLoading: false,
                proCrearLoad: false,
                proCrearError: action.payload,
                proCrear: []
            }

        case APROBACION_SOLICITUD_LOADING:
            return {
                ... state,
                aprobLoading: true,
                aprobLoad: false,
                aprobError: '',
                aprob: []
            }
        case APROBACION_SOLICITUD_LOADED:
            return {
                ...state,
                aprobLoading: false,
                aprobLoad: true,
                aprobError: '',
                aprob: action.payload,
                proyectoDetalle: {
                    ...state.proyectoDetalle,
                    Usuarios_Registrados: [
                        ...state.proyectoDetalle.Usuarios_Registrados,
                        action.payload?.usuario
                    ]
                }   
            };
        case APROBACION_SOLICITUD_ERROR:
            return {
                ...state,
                aprobLoading: false,
                aprobLoad: false,
                aprobError: action.payload,
                aprob: []
            }

        case PROYECTO_SOLICITUDES_LOADING:
            return {
                ... state,
                prosolicLoading: true,
                prosolicLoad: false,
                prosolicError: '',
                prosolic: []
            }
        case PROYECTO_SOLICITUDES_LOADED:
            return {
                ...state,
                prosolicLoading: false,
                prosolicLoad: true,
                prosolicError: '',
                prosolic: action.payload
            };
        case PROYECTO_SOLICITUDES_ERROR:
            return {
                ...state,
                prosolicLoading: false,
                prosolicLoad: false,
                prosolicError: action.payload,
                prosolic: []
            }

        case MIS_PROYECTOS_LOADING:
            return {
                ... state,
                misproyectosLoading: true,
                misproyectosLoad: false,
                misproyectosError: '',
                misproyectos: []
            }
        case MIS_PROYECTOS_LOADED:
            return {
                ...state,
                misproyectosLoading: false,
                misproyectosLoad: true,
                misproyectosError: '',
                misproyectos: action.payload
            };
        case MIS_PROYECTOS_ERROR:
            return {
                ...state,
                misproyectosLoading: false,
                misproyectosLoad: false,
                misproyectosError: action.payload,
                misproyectos: []
            }

        case PROYECTO_SOLICITUD_LOADING:
            return {
                ... state,
                solicitudLoading: true,
                solicitudLoad: false,
                solicitudError: '',
                solicitud: []
            }
        case PROYECTO_SOLICITUD_LOADED:
            return {
                ...state,
                solicitudLoading: false,
                solicitudLoad: true,
                solicitudError: '',
                solicitud: action.payload
            };
        case PROYECTO_SOLICITUD_ERROR:
            return {
                ...state,
                solicitudLoading: false,
                solicitudLoad: false,
                solicitudError: action.payload,
                solicitud: []
            }

        case PROYECTO_DETALLE_LOADING:
            return {
                ... state,
                proyectoDetalleLoading: true,
                proyectoDetalleLoad: false,
                proyectoDetalleError: '',
                proyectoDetalle: []
            }
        case PROYECTO_DETALLE_LOADED:
            return {
                ...state,
                proyectoDetalleLoading: false,
                proyectoDetalleLoad: true,
                proyectoDetalleError: '',
                proyectoDetalle: action.payload
            };
        case PROYECTO_DETALLE_ERROR:
            return {
                ...state,
                proyectoDetalleLoading: false,
                proyectoDetalleLoad: false,
                proyectoDetalleError: action.payload,
                proyectoDetalle: []
            }

        case PROYECTO_LOADING:
            return {
                ... state,
                proyectoLoading: true,
                proyectoLoad: false,
                proyectoError: '',
                proyecto: []
            }
        case PROYECTO_LOADED:
            return {
                ...state,
                proyectoLoading: false,
                proyectoLoad: true,
                proyectoError: '',
                proyecto: action.payload
            };
        case PROYECTO_ERROR:
            return {
                ...state,
                proyectoLoading: false,
                proyectoLoad: false,
                proyectoError: action.payload,
                proyecto: []
            }
        default: return state;
    }
}